"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayPeriodHourlyBreakdownView = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Card_1 = require("@amzn/atoz-web/Card");
const Col_1 = require("@amzn/atoz-web/Col");
const Theme_1 = require("@amzn/atoz-web/Theme");
const Text_1 = require("@amzn/atoz-web/Text");
const Table_1 = require("@amzn/atoz-web/Table");
const SpinnerOverlay_1 = require("../SpinnerOverlay");
const usePayPeriodHourlyBreakdownView_1 = require("./hooks/usePayPeriodHourlyBreakdownView");
const PayPeriodHourlyBreakdownViewTypes_1 = require("./PayPeriodHourlyBreakdownViewTypes");
const utils_1 = require("../../features/Timecard/utils");
const consts_1 = require("../../consts");
const logger_1 = require("../../logger");
const utils_2 = require("../../utils");
const components_1 = require("../../components");
const Link_1 = require("@amzn/atoz-web/Link");
const Row_1 = require("@amzn/atoz-web/Row");
const paycodesWithRedirectLink = new Map([
    [components_1.VTOPaycode.US_VTO.toString(), consts_1.ATOZ_FEATURE_PATH.REPLACE_VTO],
    [components_1.UptPaycode.US_Unpaid_Time.toString(), consts_1.ATOZ_FEATURE_PATH.ATTENDANCE],
    [components_1.UptPaycode.US_FC_Unpaid_Time.toString(), consts_1.ATOZ_FEATURE_PATH.ATTENDANCE]
]);
const PayPeriodHourlyBreakdownView = ({ payPeriodHourlyBreakdown, isLoading, isRequestTimecardCorrForWebEnabled = false, isReplaceVTOFeatureEnabled = false, isTimecardV2Enabled = false }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: logger_1.METRICS.TIMECARD_REQUEST_CORR_LINK.COUNT
        },
        isComponentLoaded: isRequestTimecardCorrForWebEnabled
    });
    const navigateToAttendanceOrReplaceVTOWorkflow = (data) => {
        return () => {
            if (paycodesWithRedirectLink.has(data.timeType)) {
                location.assign(paycodesWithRedirectLink.get(data.timeType));
            }
        };
    };
    const timeTypeCell = ({ data }) => {
        const timeTypeStr = (0, utils_2.getPayCodeLocalization)(data.timeType, t);
        return (react_1.default.createElement(Col_1.Col, null,
            (0, utils_1.isUptTimeType)(data.timeType) && (react_1.default.createElement(Text_1.Text, { fontSize: 'S100', dataTestId: PayPeriodHourlyBreakdownViewTypes_1.UNPAID_TIME_ACTION_ROW_TEST_ID }, timeTypeStr)),
            !(0, utils_1.isUptTimeType)(data.timeType) && (react_1.default.createElement(Text_1.Text, { fontSize: 'S100' }, timeTypeStr))));
    };
    const dataCell = ({ data }) => (react_1.default.createElement(Col_1.Col, null,
        react_1.default.createElement(Text_1.Text, { fontSize: "S100" }, data.payPeriodTotal)));
    const { data, columns } = (0, usePayPeriodHourlyBreakdownView_1.usePayPeriodHourlyBreakdownView)({
        payPeriodHourlyBreakdown,
        dataCell,
        timeTypeCell
    });
    const getRowAttributes = ({ data }) => ({
        dataTestId: PayPeriodHourlyBreakdownViewTypes_1.UNPAID_TIME_ACTION_ROW_TEST_ID + `-${data.timeType}`,
        actionLabel: 'Redirect to Attendance page',
        disabled: !((0, utils_1.isUptTimeType)(data.timeType) ||
            (isReplaceVTOFeatureEnabled && data.timeType === components_1.VTOPaycode.US_VTO)),
        disabledActionLabel: 'No action for this time type',
        onClick: navigateToAttendanceOrReplaceVTOWorkflow(data)
    });
    const payPeriodHourlyBreakdownV1 = () => {
        return (react_1.default.createElement(StyledCardV1, { flex: 1 },
            react_1.default.createElement(SpinnerOverlay_1.SpinnerOverlay, { isLoading: isLoading },
                react_1.default.createElement(Col_1.Col, { dataTestId: PayPeriodHourlyBreakdownViewTypes_1.PAY_PERIOD_HOURLY_BREAKDOWN_VIEW_TEST_ID, width: '100%', gridGap: "S200" },
                    react_1.default.createElement(Text_1.H2, { fontSize: "T200" },
                        react_1.default.createElement("strong", null, t('time_and_attendance_Timecard_PayPeriodHourlyBreakDown_TotalHours'))),
                    react_1.default.createElement(Table_1.Table, { columns: columns, data: data, "aria-label": t('time_and_attendance_Timecard_PayPeriodHourlyBreakDown_TotalHours'), getRowAttributes: getRowAttributes, actionHeader: t('time_and_attendance_Timecard_PayPeriodBreakDown_Details') })))));
    };
    const renderV2Paycodes = (timeType) => {
        const timeTypeStr = (0, utils_2.getPayCodeLocalization)(timeType, t);
        if (paycodesWithRedirectLink.has(timeType)) {
            return (react_1.default.createElement(Link_1.Link, { fontSize: "T200", onClick: () => location.assign(paycodesWithRedirectLink.get(timeType)), dataTestId: timeType }, timeTypeStr));
        }
        else {
            return (react_1.default.createElement(Text_1.Text, { fontSize: "T200", dataTestId: timeType }, timeTypeStr));
        }
    };
    const payPeriodHourlyBreakdownV2 = () => {
        return (react_1.default.createElement(StyledCardV2, { flex: 1 },
            react_1.default.createElement(SpinnerOverlay_1.SpinnerOverlay, { isLoading: isLoading },
                react_1.default.createElement(Col_1.Col, { dataTestId: PayPeriodHourlyBreakdownViewTypes_1.PAY_PERIOD_HOURLY_BREAKDOWN_VIEW_V2_TEST_ID, width: '100%', gridGap: "S200" }, data.map(({ timeType, payPeriodTotal }) => {
                    return (react_1.default.createElement(Row_1.Row, { padding: "S200", justifyContent: 'space-between', width: '100%', key: timeType },
                        renderV2Paycodes(timeType),
                        react_1.default.createElement(Text_1.Text, { fontSize: "T200" }, payPeriodTotal)));
                })))));
    };
    if (isTimecardV2Enabled)
        return react_1.default.createElement(react_1.default.Fragment, null,
            " ",
            payPeriodHourlyBreakdownV2());
    else
        return react_1.default.createElement(react_1.default.Fragment, null,
            " ",
            payPeriodHourlyBreakdownV1());
};
exports.PayPeriodHourlyBreakdownView = PayPeriodHourlyBreakdownView;
const StyledCardV1 = (0, Theme_1.styledWithTheme)(Card_1.Card)(`
    border: none;
    width: 100%;
`);
const StyledCardV2 = (0, Theme_1.styledWithTheme)(Card_1.Card)(`
    padding: 0;
    border: none;
    width: 100%;
`);
